// extracted by mini-css-extract-plugin
export var contentBody = "_5b-9";
export var headerImage = "_5b-2";
export var imageButton = "_5b-7";
export var imageButtonIcon = "_5b-8";
export var imageHeader = "_5b-4";
export var imageHeaderText = "_5b-5";
export var imageOverlay = "_5b-3";
export var imageTitle = "_5b-6";
export var imageWrapper = "_5b-1";
export var taskList = "_5b-a";
export var widget = "_5b-0";